export default "__VITE_ASSET__0412237a__"